<template>
    <div class="w-full flex justify-between space-x-2">
        <nav class="flex" aria-label="Breadcrumb">
            <ol class="flex items-center space-x-2">
                <li v-for="(page, index) in pages" :key="page.name">
                    <div class="flex items-center">
                        <svg
                            v-if="index !== 0"
                            class="mr-1 shrink-0 h-5 w-5 text-gray-400"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <span v-if="page.href === null" class="text-sm">
                            {{ page.name }}
                        </span>
                        <component
                            :is="type"
                            v-bind="$attrs"
                            v-else
                            :href="page.href"
                            class="text-base text-indigo-500 hover:text-indigo-700"
                        >
                            {{ page.name }}
                        </component>
                    </div>
                </li>
            </ol>
        </nav>

        <slot name="corner"></slot>
    </div>
</template>

<script>
export default {
    name: 'SmartBreadcrumbs',
};
</script>
<script setup>
import { computed } from 'vue';
import { useTitle } from '@vueuse/core';

const props = defineProps({
    pages: {
        type: Array,
        required: true,
    },
    type: {
        type: String,
        default: 'a',
    },
});

const title = computed(() => {
    return props.pages.map((page) => page.name).join(' - ');
});
useTitle(title);
</script>
